const ComprehensiveSupportIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3480_119028)">
        <path
          d="M29.2156 47.2537L31.5023 49.1032C32.6553 50.0503 34.3528 49.9072 35.331 48.7804C35.9709 48.0434 35.8949 46.9278 35.161 46.2843L32.1273 43.6242L37.1481 48.0267C38.337 49.0692 40.1469 48.946 41.1836 47.752L41.4301 47.468C42.1171 46.6769 42.031 45.4782 41.238 44.7934L30.9104 35.8741L43.305 46.5785C44.3002 47.438 45.8063 47.317 46.6515 46.3095L47.7181 45.038C48.2114 44.4499 47.9784 43.5744 47.3962 43.0743L35.5107 32.7266L48.6083 43.9768C49.2167 44.4993 50.1386 44.4058 50.6295 43.7717L51.3028 42.9023C52.0498 41.9376 51.9408 40.563 51.0511 39.728L49.9974 38.7392"
          stroke="#027C80"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5279 38.9576L9.03906 35.3047"
          stroke="#027C80"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.6535 43.4562L29.6535 43.4562C30.4634 44.0404 30.6464 45.1705 30.0622 45.9804L28.6097 47.9941C28.0255 48.804 26.8954 48.987 26.0855 48.4028L26.0855 48.4028C25.2756 47.8186 25.0926 46.6885 25.6768 45.8786L27.1293 43.8649C27.7134 43.055 28.8436 42.872 29.6535 43.4562Z"
          stroke="#06AEB3"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.0248 40.3001L27.0248 40.3002C27.9964 41.0009 28.2159 42.3567 27.5151 43.3282L25.2942 46.4074C24.5934 47.3789 23.2376 47.5985 22.2661 46.8977L22.2661 46.8977C21.2945 46.1969 21.075 44.8411 21.7758 43.8696L23.9967 40.7904C24.6975 39.8189 26.0532 39.5994 27.0248 40.3001Z"
          stroke="#06AEB3"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.8864 37.2064L23.8864 37.2064C24.858 37.9072 25.0775 39.2629 24.3767 40.2345L21.4652 44.2709C20.7644 45.2425 19.4087 45.462 18.4371 44.7612L18.4371 44.7612C17.4656 44.0604 17.246 42.7047 17.9468 41.7331L20.8583 37.6967C21.5591 36.7251 22.9148 36.5056 23.8864 37.2064Z"
          stroke="#06AEB3"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.3984 35.9173L19.3984 35.9173C20.3699 36.6181 20.5895 37.9739 19.8887 38.9454L17.2685 42.5781C16.5677 43.5496 15.2119 43.7692 14.2404 43.0684L14.2404 43.0684C13.2688 42.3676 13.0493 41.0118 13.7501 40.0403L16.3703 36.4076C17.0711 35.4361 18.4268 35.2165 19.3984 35.9173Z"
          stroke="#06AEB3"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M29.7004 17.1641H27.4958C26.5023 17.1641 25.521 17.3827 24.6214 17.8044L24.2863 17.9615C23.3868 18.3832 22.4055 18.6018 21.412 18.6018H15.1501"
          stroke="#027C80"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.5279 18.5979C14.5279 18.5979 15.0114 26.6685 7.90921 36.9182L0 34.5777C0 34.5777 5.08449 27.4756 7.74779 14.8047L14.5271 18.4365"
          stroke="#FFA473"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55.082 35.0258L49.9975 38.7383L34.8098 25.2553C34.4035 24.8946 33.8791 24.6954 33.3358 24.6954H32.4354C31.8466 24.6954 31.2819 24.9293 30.8655 25.3457L28.3548 27.8564C26.8691 29.3422 24.4602 29.3422 22.9744 27.8564C22.2833 27.1653 22.2394 26.059 22.8737 25.3153L23.5598 24.511C23.91 24.1004 24.1709 23.6214 24.326 23.1045L24.7083 21.8301C24.9363 21.07 25.4012 20.4026 26.035 19.9252L30.0263 16.9189C30.9056 16.2566 31.9766 15.8984 33.0774 15.8984H34.9693C35.8826 15.8984 36.7832 16.1119 37.5994 16.5217L40.6121 18.0345C41.6865 18.574 42.8869 18.8124 44.0858 18.7245L47.2946 18.4891"
          stroke="#06AEB3"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.1284 18.4261L54.3959 14L63.9999 33.3695L56.7364 36.8399C56.7364 36.8399 53.1853 34.1765 48.1815 18.6003"
          stroke="#FFA374"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M50.5624 39.2226L34.9861 25.4219"
          stroke="#027C80"
          strokeWidth="1.37201"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3480_119028">
          <rect
            width="64"
            height="64"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ComprehensiveSupportIcon;
